import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import combineStyles from '../../../utils/combineStyles';
import TypographyStyles from '../../../styles/typography';
import LayoutStyles from '../../../styles/layout';
import SpacingStyles from '../../../styles/helpers/spacing';
import ProgressBar from './ProgressBar';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/MoreHoriz';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Pickup from './Pickup';
import FormItemContainerStyles from '../../Global/Containers/__styles__/FormItemContainer.styles';
import _get from 'lodash/get';
import Delivery from './Delivery';
import StatusStyles from './__styles__/Status.styles';
import StatusLabel from './StatusLabel';
import { SHIPMENT_STATUS } from './../../../constants/constants';
import TenderShipmentModal from './modals/TenderShipment.modal';
import * as helpers from './helpers';
import _pick from 'lodash/pick';
import { buildTimestamp } from '../../../utils/DateTime';
import ExceptionModal from './modals/Exception.modal';
import DeleteShipmentModal from './modals/DeleteShipment.modal';
import CancelShipmentModal from './modals/CancelShipment.modal';
import NotificationSnackbar from './../../common/NotificationSnackbar';
import Tooltip from '@material-ui/core/Tooltip';
import { AppContext } from '../../../AppProvider';

const PICKUP_TYPE = 'Pickup';

export class Status extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onShipmentTender: PropTypes.func.isRequired,
    onShipmentWaitingPickup: PropTypes.func.isRequired,
    onShipmentDelivered: PropTypes.func.isRequired,
    onPlannedDateUpdate: PropTypes.func.isRequired,
    onDeleteShipment: PropTypes.func.isRequired,
    onCancelShipment: PropTypes.func.isRequired,
    onActualDateUpdate: PropTypes.func.isRequired,
    onReverseShipmentStatus: PropTypes.func.isRequired,
    onShipmentException: PropTypes.func.isRequired,
    onShipmentResume: PropTypes.func.isRequired,
    onAutoTenderShipment: PropTypes.func.isRequired,

    editable: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    cancellationReasons: PropTypes.array,
    isAuthenticated: PropTypes.bool.isRequired
  };
  state = {
    menuElement: null,
    displayTenderShipmentModal: false,
    displayExceptionModal: false,
    displayDeleteShipmentModal: false,
    displayDeleteNotification: false,
    displayCancelModal: false,
    shipmentStatusId: this.props.shipment.shipmentStatusId,
    shipmentViewModel: {
      shipmentId: this.props.shipment.id,
      proNumber: this.props.shipment.proNumber,
      previousShipmentStatusId: this.props.shipment.previousShipmentStatusId,
      carrierPickupNumber: this.props.shipment.carrierPickupNumber,
      shipmentStatusId: this.props.shipment.shipmentStatusId,
      rowVersion: this.props.shipment.rowVersion,
      pickup: _pick(this.props.shipment.pickup, helpers.fieldsToPick),
      delivery: _pick(this.props.shipment.delivery, helpers.fieldsToPick)
    }
  };
  _getStatusLabel = () => {
    const { t, shipment } = this.props;
    const { shipmentStatusId } = shipment;
    // TODO: Change Status Labels to use the reference data from the backend
    const labels = {
      [SHIPMENT_STATUS.SAVED]: t('Saved'),
      [SHIPMENT_STATUS.READY_TO_TENDER]: t('Ready to tender'),
      [SHIPMENT_STATUS.WAITING_FOR_PICKUP]: t('Waiting for pickup'),
      [SHIPMENT_STATUS.IN_TRANSIT]: t('In transit'),
      [SHIPMENT_STATUS.DELIVERED]: t('Delivered'),
      [SHIPMENT_STATUS.SAVED]: t('Saved'),
      [SHIPMENT_STATUS.CANCELLED]: t('Cancelled'),
      [SHIPMENT_STATUS.AUTO_TENDERING]: t('Tendering'),
      [SHIPMENT_STATUS.TENDER_REQUESTED]: t('Tendering'),
      [SHIPMENT_STATUS.AUTO_TENDER_TRANSIENT_FAILURE]: t('Tendering'),
      [SHIPMENT_STATUS.AUTO_TENDER_PERMANENT_FAILURE]: t('Tender Failed'),
      [SHIPMENT_STATUS.TENDER_REJECTED]: t('Tender Rejected')
    };
    return _get(labels, shipmentStatusId, t('Exception'));
  };
  _handleMenuClick = event => {
    this._safeSetState({ menuElement: event.currentTarget });
  };
  _handleMenuClose = () => {
    this._safeSetState({ menuElement: null });
  };
  _toggleModalDisplay = modalType => {
    const currentModalStatus = this.state[modalType];
    this._safeSetState({ [modalType]: !currentModalStatus, menuElement: null });
  };
  _toggleDisplayTenderShipmentModal = () => {
    const { displayTenderShipmentModal } = this.state;
    this._safeSetState({
      displayTenderShipmentModal: !displayTenderShipmentModal
    });
  };
  _toggleDisplayExceptionModal = () => {
    const { displayExceptionModal } = this.state;
    this._safeSetState({ displayExceptionModal: !displayExceptionModal });
  };
  _toggleDisplayDeleteShipmentModal = () => {
    const { displayDeleteShipmentModal } = this.state;
    this._safeSetState({
      displayDeleteShipmentModal: !displayDeleteShipmentModal,
      menuElement: null
    });
  };
  _handleSaveShipmentTendered = async values => {
    const { onShipmentTender } = this.props;
    const updatedSuccessfully = await onShipmentTender(values);
    if (updatedSuccessfully) {
      this._toggleDisplayTenderShipmentModal();
    }
  };
  _handleDeleteShipment = async () => {
    const { onDeleteShipment } = this.props;
    const isSuccessful = await onDeleteShipment();

    if (isSuccessful) {
      this._toggleDisplayDeleteShipmentModal();
      this._safeSetState({ displayDeleteNotification: true });
    }
  };

  _handleDeleteOnClose = () => {
    const { history } = this.props;
    history.push('/shipments');
  };
  _handlePlannedDateSave = async (type, values) => {
    const {
      shipmentViewModel: { pickup, delivery }
    } = this.state;
    const { onPlannedDateUpdate } = this.props;
    const updateObject = {
      stopId: type === 'pickup' ? pickup.id : delivery.id,
      plannedFromTimeLocal: null,
      plannedToTimeLocal: null
    };

    updateObject.plannedFromTimeLocal = buildTimestamp(
      values.plannedDate,
      values.openFromTimeLocal
    );
    updateObject.plannedToTimeLocal = buildTimestamp(
      values.plannedDate,
      values.openToTimeLocal
    );

    const wasSuccessful = await onPlannedDateUpdate(updateObject);
    return wasSuccessful;
    //    console.log(updateObject);
    //   originalShipment[type] = values;
    // this.setState({ shipment: originalShipment });
  };
  _handleActualDateSave = async (type, values) => {
    const {
      onShipmentWaitingPickup,
      onActualDateUpdate,
      onShipmentDelivered
    } = this.props;
    const { shipmentStatusId } = this.state;
    if (type === PICKUP_TYPE) {
      const mutationObject = {
        actualPickupTimeLocal: buildTimestamp(
          values.actualDate,
          values.actualTime
        ),
        considerPickupLate: values.carrierWasLate
      };
      if (shipmentStatusId === SHIPMENT_STATUS.WAITING_FOR_PICKUP) {
        try {
          await onShipmentWaitingPickup(mutationObject);
          return;
        } catch (e) {
          //TODO Handle this exception
        }
        return;
      } else {
        try {
          await onActualDateUpdate(mutationObject);
          return;
        } catch (e) {
          //TODO Handle this exception
        }
      }
    } else {
      const mutationObject = {
        actualDeliveryTimeLocal: buildTimestamp(
          values.actualDate,
          values.actualTime
        ),
        considerDeliveryLate: values.carrierWasLate
      };
      if (shipmentStatusId === SHIPMENT_STATUS.IN_TRANSIT) {
        try {
          await onShipmentDelivered(mutationObject);
          return;
        } catch (e) {
          //TODO Handle this exception
        }
        return;
      } else {
        try {
          await onActualDateUpdate(mutationObject);
          return;
        } catch (e) {
          //TODO Handle this exception
        }
      }
    }
  };
  _reverseShipmentStatus = async () => {
    await this.props.onReverseShipmentStatus();
    this._handleMenuClose();
  };
  _handleTenderShipment = async () => {
    await this.props.onAutoTenderShipment();
    this._handleMenuClose();
  };

  _isMounted = false;
  _safeSetState = state => {
    if (!this._isMounted) return;
    this.setState(state);
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      classes,
      t,
      onShipmentException,
      editable,
      isAuthenticated,
      onCancelShipment,
      onShipmentResume,
      shipment
    } = this.props;
    const {
      menuElement,
      displayTenderShipmentModal,
      displayExceptionModal,
      displayCancelModal,
      displayDeleteShipmentModal,
      displayDeleteNotification,
      shipmentStatusId,
      shipmentViewModel
    } = this.state;
    const { orgInfo } = this.context.globalProps;
    const textColor = helpers.READ_ONLY_STATUSES.includes(shipmentStatusId)
      ? classes.readOnlyColor
      : '';
    const menuOptions = editable
      ? helpers.buildMenu(
          shipment,
          orgInfo,
          {
            exception: this._toggleDisplayExceptionModal,
            closeMenu: this._handleMenuClose,
            revert: this._reverseShipmentStatus,
            delete: this._toggleDisplayDeleteShipmentModal,
            resumeShipment: onShipmentResume,
            tenderShipment: this._handleTenderShipment,
            cancel: () => {
              this._toggleModalDisplay('displayCancelModal');
            }
          },
          t
        )
      : [];
    const cancellationReasons = isAuthenticated
      ? helpers.buildCancellationReasons(this.props.cancellationReasons)
      : [];

    return (
      <div className={classnames(classes.root, classes.container)}>
        <div
          className={classnames(
            classes.titleContentDivider,
            classes.titleRowContainer
          )}
        >
          <h2 className={classnames(classes.headline8)}>{t('Status')}</h2>
          <div className={classes.statusTextContainer}>
            <StatusLabel
              label={this._getStatusLabel()}
              type={shipmentViewModel.shipmentStatusId}
            />
          </div>
          <div className={classes.secondaryActions}>
            {helpers.allowTender(shipment) && (
              <Button
                variant="contained"
                color="primary"
                className={classes.shipmentTenderedButton}
                onClick={() => {
                  this._toggleDisplayTenderShipmentModal();
                }}
              >
                {t('Shipment Tendered')}
              </Button>
            )}
            {!!menuOptions.length && (
              <IconButton
                color="primary"
                onClick={this._handleMenuClick}
                classes={{
                  root: classnames(classes.noPadding, classes.statusMenu)
                }}
              >
                <MenuIcon />
              </IconButton>
            )}
          </div>
        </div>
        <div>
          <div className={classes.progressBarContainer}>
            <ProgressBar status={shipmentViewModel.shipmentStatusId} />
          </div>

          <Grid
            container
            spacing={0}
            classes={{ container: classes.locationsContainer }}
          >
            <Grid item lg={3}>
              <div
                className={classnames(
                  classes.locationName,
                  classes.headline7,
                  textColor
                )}
              >
                {isAuthenticated ? (
                  _get(shipmentViewModel, 'pickup.locationName', '')
                ) : (
                  <Tooltip
                    title={_get(
                      shipmentViewModel,
                      'pickup.locationAddress.postalCode',
                      ''
                    )}
                    classes={{
                      tooltip: classnames(classes.caption, classes.tooltip),
                      popper: classes.tooltipPopper
                    }}
                    placement="top"
                  >
                    <div>
                      {`${_get(
                        shipmentViewModel,
                        'pickup.locationAddress.city',
                        ''
                      ) || ' - '}, ${_get(
                        shipmentViewModel,
                        'pickup.locationAddress.state',
                        ''
                      ) || ' - '}`}
                    </div>
                  </Tooltip>
                )}
              </div>
            </Grid>
            <Grid item lg={3}>
              <Pickup
                shipmentStatusId={shipmentViewModel.shipmentStatusId}
                stop={shipmentViewModel.pickup}
                editable={editable}
                onPlannedDateSave={this._handlePlannedDateSave}
                onActualDateSave={this._handleActualDateSave}
              />
            </Grid>
            <Grid item lg={3}>
              <div
                className={classnames(
                  classes.locationName,
                  classes.headline7,
                  textColor
                )}
              >
                {isAuthenticated ? (
                  _get(shipmentViewModel, 'delivery.locationName', '')
                ) : (
                  <Tooltip
                    title={_get(
                      shipmentViewModel,
                      'delivery.locationAddress.postalCode',
                      ''
                    )}
                    classes={{
                      tooltip: classnames(classes.caption, classes.tooltip),
                      popper: classes.tooltipPopper
                    }}
                    placement="top"
                  >
                    <div>
                      {`${_get(
                        shipmentViewModel,
                        'delivery.locationAddress.city',
                        ''
                      ) || ' - '}, ${_get(
                        shipmentViewModel,
                        'delivery.locationAddress.state',
                        ''
                      ) || ' - '}`}
                    </div>
                  </Tooltip>
                )}
              </div>
            </Grid>
            <Grid item lg={3}>
              <Delivery
                shipmentStatusId={shipmentViewModel.shipmentStatusId}
                stop={shipmentViewModel.delivery}
                editable={editable}
                onPlannedDateSave={this._handlePlannedDateSave}
                onActualDateSave={this._handleActualDateSave}
              />
            </Grid>
          </Grid>
        </div>
        <Menu
          anchorEl={menuElement}
          open={Boolean(menuElement)}
          onClose={this._handleMenuClose}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {menuOptions.map((option, index) => {
            return (
              <MenuItem key={index} onClick={option.action}>
                {option.label}
              </MenuItem>
            );
          })}
        </Menu>
        <TenderShipmentModal
          open={displayTenderShipmentModal}
          onClose={this._toggleDisplayTenderShipmentModal}
          onSave={this._handleSaveShipmentTendered}
        />
        {isAuthenticated && (
          <ExceptionModal
            open={displayExceptionModal}
            onClose={this._toggleDisplayExceptionModal}
            onSave={onShipmentException}
          />
        )}
        <DeleteShipmentModal
          open={displayDeleteShipmentModal}
          onClose={this._toggleDisplayDeleteShipmentModal}
          onSave={this._handleDeleteShipment}
        />
        {isAuthenticated && (
          <CancelShipmentModal
            open={displayCancelModal}
            cancellationReasons={cancellationReasons}
            onClose={() => {
              this._toggleModalDisplay('displayCancelModal');
            }}
            onSave={onCancelShipment}
          />
        )}
        <NotificationSnackbar
          open={displayDeleteNotification}
          handleSnackbarClose={this._handleDeleteOnClose}
          message={`${t('Shipment')} ${shipmentViewModel.shipmentId} ${t(
            'has been deleted'
          )}`}
          autoHide={2000}
        />
      </div>
    );
  }
}
Status.contextType = AppContext;
const translatedStatus = withNamespaces()(Status);
export default withStyles(
  combineStyles(
    FormItemContainerStyles,
    StatusStyles,
    TypographyStyles,
    SpacingStyles,
    LayoutStyles
  )
)(translatedStatus);
